import React from 'react'

import Text from 'components/common/Text'
import Tooltip2 from 'components/common/Tooltip2.0'

import { ButtonWrapper, ControlTooltip, TabWrapper, Cross } from '../../styles'

const LeftControlBarTab = ({
    iconProps,
    iconExtras,
    isEnabled,
    isDisabled,
    onClick,
    title,
    tooltipPlacement = 'bottom',
    children,
    enabledTooltip,
    disabledTooltip,
    rightControl,
    fixedLeft,
    className,
    activeColor,
}) => {
    if (
        !fixedLeft &&
        ((rightControl && isEnabled) || (!rightControl && !isEnabled))
    )
        return null

    // rightControl && !isEnabled => IconView
    // rightControl && isEnabled => null

    // leftControl && isEnabled => TabView
    // leftControl && isDisabled => TabView
    // leftControl && !isEnabled => null

    /* tooltip content */
    const getEnabledTooltip = enabledTooltip ?? `stop ${title}`
    const getDisbledTooltip = disabledTooltip ?? `start ${title}`
    let tooltip = isEnabled ? getEnabledTooltip : getDisbledTooltip

    if (isDisabled) tooltip = `cannot start ${title}`

    const iconView = (
        <>
            <ButtonWrapper
                enabled={isEnabled}
                isDisabled={isDisabled}
                className="button-wrapper"
            >
                <img {...iconProps} />
            </ButtonWrapper>
            {iconExtras}
        </>
    )

    const cross =
        onClick && !isDisabled ? (
            <Tooltip2
                content={isEnabled ? tooltip : null}
                placement={tooltipPlacement}
            >
                <Cross.Wrapper onClick={onClick}>
                    <Cross.Icon src="/assets/revamp/end.svg" />
                </Cross.Wrapper>
            </Tooltip2>
        ) : null

    const tabView = (
        <TabWrapper className="tab-wrapper" $activeColor={activeColor}>
            {iconView}
            {title && (
                <Text level="2" css="text-transform: capitalize;">
                    {children && children}
                    &nbsp;
                    {title}
                </Text>
            )}
            {cross}
        </TabWrapper>
    )

    let view = null

    if ((!rightControl || fixedLeft) && (isEnabled || isDisabled)) {
        view = tabView
    } else if ((rightControl || fixedLeft) && (!isEnabled || isDisabled)) {
        view = iconView
    }

    if (view)
        return (
            <ControlTooltip
                $isDisabled={isDisabled}
                content={!isEnabled ? tooltip : null}
                placement={tooltipPlacement}
                onClick={onClick}
                $rightControl={rightControl}
                className={className}
            >
                {view}
            </ControlTooltip>
        )

    return null
}

export default LeftControlBarTab
